import type { MenuProps } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { useStoreActions, useStoreState } from '../../store';
import type { Locale } from '../../store/i18n';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  locale: {
    marginLeft: '10px',
    marginRight: '8px',
    verticalAlign: 'top',
    cursor: 'pointer',
    transition: 'all .3s',
  },
  icon: {
    fontSize: '1.2em',
  },
});

export const LocaleDropdown = () => {
  const setLocale = useStoreActions((actions) => actions.i18n.setLocale);
  const activeLocale = useStoreState((state) => state.i18n.activeLocale);
  const handleLocaleClick = (locale: Locale) => {
    setLocale(locale);
  };
  const classes = useStyles();

  const items: MenuProps['items'] = [
    {
      key: 'en_US',
      label: (
        <span>
          <span role="img" aria-label="English">
            🇺🇸
          </span>
          English
        </span>
      ),
    },
    {
      key: 'es_ES',
      label: (
        <span>
          <span role="img" aria-label="Español">
            🇪🇸
          </span>
          Español
        </span>
      ),
    },
    {
      key: 'fr_FR',
      label: (
        <span>
          <span role="img" aria-label="Français">
            🇫🇷
          </span>
          Français
        </span>
      ),
    },
    {
      key: 'zh_CN',
      label: (
        <span>
          <span role="img" aria-label="简体中文">
            🇨🇳
          </span>
          简体中文
        </span>
      ),
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    handleLocaleClick(key as Locale);
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
    selectedKeys: [activeLocale],
  };

  return (
    <Dropdown menu={menuProps}>
      <span className={classes.locale}>
        <GlobalOutlined className={classes.icon} />
      </span>
    </Dropdown>
  );
};
